module.exports = __webpack_public_path__ + "static/media/Folder.21a08852.png";